export default {"src":"/_next/static/media/products-tool.06c6e8f0.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};